import CompanyWorkListContent from "../../features/companyWork/widgets/CompanyWorkListContent";

function CompanyWorkListScreen() {
  return <CompanyWorkListContent />;
}

export default CompanyWorkListScreen;
